import mutationsTypes from '@/vuex/reencaminhamento-documento/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_LISTA_UNIDADES: 'GET_LISTA_UNIDADES',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO: 'RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO',
  REALIZAR_REENCAMINHAMENTO: 'REALIZAR_REENCAMINHAMENTO'
}

export default types
